import { PropTypes } from 'prop-types';
import React from 'react';
import _ from 'lodash';

class ActiveFilterList extends React.Component {
    render() {
        let items = [];
        let flatFilter = [];
        let activeFilterHeading = '';
        let hasSearch = false;

        _(this.props.filter).forEach((value, name) => {
            if (value) {
                if (name === 'text') {
                    flatFilter.push({ name, value });
                } else {
                    _(value).forEach(val => {
                        flatFilter.push({ name, value: val });
                    });
                }
            }
        });

        _(flatFilter).forEach((f, name) => {
            if (!f) {
                return false;
            }

            if (f.value.name !== undefined) {
                activeFilterHeading += ` ${f.value.name},`;
            }

            let classList = ['active-filter'];
            let filterClick = () => this.props.onFilterClick(f.name, f.value);
            let filterContent = (
                <a
                    className="filter-option-remove"
                    href="#"
                    key={name}
                    onClick={filterClick}
                    aria-label={`Remove filter: ${f.value.name}`}
                    dangerouslySetInnerHTML={{ __html: f.value.name }}
                />
            );

            if (f.name === 'text') {
                hasSearch = true;
                classList.push('text-filter');
                filterClick = this.props.onTextFilterClick;
                filterContent = (<span>Matches: <strong>“{this.props.filter.text}”</strong></span>);
            }

            let item = (
                <li
                    className={classList.join(' ')}
                >
                    {filterContent}
                </li>
            );

            items.push(item);
        });

        if (items.length === 0) {
            return null;
        } else if (items.length > 1) {
            items.push(
                <li
                    key="clear-filter"
                    className="active-filter clear-filter"
                    onClick={this.props.onClearFiltersClick}
                >
                    <a href="#" className="filter-option-remove clear-filter-link">Clear all filters</a>
                </li>
            );
        }

        if (hasSearch === true) {

            if (activeFilterHeading === '') {
                activeFilterHeading = `Browsing items matching “${this.props.filter.text}”`;
            } else {
                activeFilterHeading = `Browsing items filed under${activeFilterHeading}, and matching “${this.props.filter.text}”`;
            }

        } else {

            activeFilterHeading = `Browsing items filed under${activeFilterHeading}`;
        }

        if (activeFilterHeading.substring(activeFilterHeading.length - 1) === ',') {
            activeFilterHeading = activeFilterHeading.substring(0, activeFilterHeading.length - 1);
        }

        return (
            <div className="active-filters">
                <div className="container">
                    <h2
                        className="active-filters-heading screen-reader-text"
                        aria-live="polite"
                        dangerouslySetInnerHTML={{ __html: activeFilterHeading }}
                    />
                    <ul className="active-filter-items">{items}</ul>
                </div>
            </div>
        );
    }
}

ActiveFilterList.propTypes = {
    filter: PropTypes.object.isRequired,
    onFilterClick: PropTypes.func.isRequired,
    onTextFilterClick: PropTypes.func.isRequired,
    onClearFiltersClick: PropTypes.func.isRequired
};

export default ActiveFilterList;



// WEBPACK FOOTER //
// ./wp-content/themes/gwy/assets/scripts/source/vpm/post-grid/components/active-filter-list.js